import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { Auth } from '../../services/auth';

@Component({
  imports: [AvatarModule, ButtonModule, MenuModule, RippleModule, RouterOutlet],
  templateUrl: './layout.html',
  styleUrl: './layout.scss'
})
export class Layout {

  public authService = inject(Auth);

  public navItems: MenuItem[] = [
    {
      separator: true
    },
    {
      label: 'Fallaufgaben',
      routerLink: '/fallaufgaben'
    },
    {
      label: 'Audit Log',
      routerLink: '/auditlog'
    },
    {
      label: 'Kategorien',
      routerLink: '/kategorien'
    },
    {
      label: 'PDF-Dokumente',
      routerLink: '/pdf-dokumente'
    },
    {
      label: 'Nutzerverwaltung',
      routerLink: '/nutzerverwaltung'
    },
    {
      label: 'Betrugswarnungen',
      routerLink: '/betrugswarnungen'
    },
    {
      label: 'Datenaufbewahrung',
      routerLink: '/datenaufbewahrung'
    }
  ]
}
